import React from "react";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import styles from "./WhatsAppButton.module.css";

interface WhatsAppButtonProps {
  className?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ className }) => {
  return (
    <div className={`${styles.whatsappContainer} ${className || ""}`}>
      <FloatingWhatsApp
        phoneNumber="+51906869576"
        accountName="Evefant"
        avatar="/favicon/web-app-manifest-192x192.png"
        statusMessage="En línea"
        chatMessage="¡Hola! 👋 ¿En qué podemos ayudarte hoy?"
        placeholder="Escribe tu mensaje..."
        allowEsc
        allowClickAway
        notification={false}
        notificationSound={false}
        darkMode={false}
        className="evefant-whatsapp-button"
      />
    </div>
  );
};

export default WhatsAppButton;
